import React from "react";
import { Route, Routes } from "react-router-dom";
import SmsPage from "../../pages/features/sms/SmsPage";
import NewSmsPage from "../../pages/features/sms/NewSmsPage";

export default function SmsNav() {
  return (
    <Routes>
      <Route path="/" element={<SmsPage />} />
      <Route path="/new" element={<NewSmsPage />} />
    </Routes>
  );
}
